export default __webpack_public_path__ + "static/media/Presents(2).99d25795.jpg";